"use script";

angular.module("customer")

// All specific constant for the build
.constant("APP_OWNER", "gromec")

// White Label Constants
.constant("COMMUNITY_INVITE_TOKEN", "bb8a06c8aad245979207d001df393ba6")
.constant("CUSTOMER_TYPE_REGISTRATION", "business") // see /core/customer-model/customer.constant.js

// Routing override
.run(function($rootScope, $state, COMMUNITY_INVITE_TOKEN) {

    $rootScope.$on("$stateChangeStart", function(event, toState, toParams) {
        if (toState.name === "full-registration" || toState.name === "registration") {
            if (!toParams) {
                event.preventDefault();
                var params = {
                    "groupInvite": COMMUNITY_INVITE_TOKEN
                };
                $state.go(toState.name, params);
            }
            else if (toParams["groupInvite"] !== COMMUNITY_INVITE_TOKEN) {
                toParams["groupInvite"] = COMMUNITY_INVITE_TOKEN;

                event.preventDefault();
                $state.go(toState.name, toParams);
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-build-constant/gromec.customizations.js
// module id = 716
// module chunks = 0